// Minimal hash-based router (no dependency on react-router).
// Usage: useRoute() returns [{ path, params }, navigate]
// Routes look like: #/matters, #/matters/:id, #/calendar, etc.

import { useEffect, useState, useCallback } from 'react';

const parseHash = () => {
  const raw = window.location.hash.replace(/^#/, '') || '/';
  const [pathname, search = ''] = raw.split('?');
  const searchParams = Object.fromEntries(new URLSearchParams(search));
  const segments = pathname.split('/').filter(Boolean);
  return { pathname, segments, searchParams };
};

export const useRoute = () => {
  const [state, setState] = useState(parseHash());
  useEffect(() => {
    const onChange = () => setState(parseHash());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  const navigate = useCallback((path) => {
    const target = path.startsWith('#') ? path : `#${path}`;
    if (window.location.hash !== target) window.location.hash = target;
    else setState(parseHash());
  }, []);
  return [state, navigate];
};

export const matchRoute = (segments, pattern) => {
  // pattern like ['matters',':id']; returns params or null
  const parts = pattern.split('/').filter(Boolean);
  if (parts.length !== segments.length) return null;
  const params = {};
  for (let i = 0; i < parts.length; i += 1) {
    if (parts[i].startsWith(':')) params[parts[i].slice(1)] = segments[i];
    else if (parts[i] !== segments[i]) return null;
  }
  return params;
};
